<!-- App Main Structure -->
<template>
  <div class="app-default-layout" aria-live="polite" id="focus-target">
    <template v-if="!session_ready">
      <preloader></preloader>
    </template>
    <template v-else>
      <!-- App Header -->
      <app-header></app-header>
      <!-- App Main Content -->
      <v-main evelation="0">
        <v-container fluid class="pt-0 pb-16 mb-16 px-md-10 px-sm-3">
          <div class="mb-6">
            <user-block />
          </div>
          <!-- App Router -->
          <transition name="router-anim" :enter-active-class="`animated ${routerAnimation}`">
            <div class="gg-container">
              <ban-alert v-if="banned" class="mb-3" />
              <router-view></router-view>
            </div>
          </transition>
        </v-container>
      </v-main>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/General/Header/Header.vue'
import Preloader from '@/components/Common/Preloader'
import UserBlock from '@/components/General/Sidebar/UserBlock'
import BanAlert from '@/components/Profile/BanAlert'

export default {
  data () {
    return {
      loading: true
    }
  },
  components: {
    appHeader: Header,
    Preloader,
    UserBlock,
    BanAlert
  },
  computed: {
    ...mapGetters(['routerAnimation', 'session_ready', 'banned'])
  }
}
</script>

<style>
.app-default-layout {
  height: 100vh;
}
.v-btn--contained {
  box-shadow: none !important; /** AM-695 remove btn shadow */
}
.container--fluid {
  max-width: 100%;
}

/* Keep page content (below the user block) in a centered column on wide screens */
.gg-container {
  max-width: 1100px;
  margin: 0 auto;
}
</style>
